/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD Thumbnails`)
};

const es_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniaturas HD`)
};

const de_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD-Thumbnails`)
};

const nl_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD-thumbnails`)
};

const fr_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniatures HD`)
};

const it_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniature HD`)
};

const pt_br2_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thumbnails HD`)
};

const pt_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miniaturas HD`)
};

const ja_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HDサムネイル`)
};

const zh_yt_hd_nav = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`HD 缩略图`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hd_nav = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hd_nav(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hd_nav", locale)
	if (locale === "en") return en_yt_hd_nav(inputs)
	if (locale === "es") return es_yt_hd_nav(inputs)
	if (locale === "de") return de_yt_hd_nav(inputs)
	if (locale === "nl") return nl_yt_hd_nav(inputs)
	if (locale === "fr") return fr_yt_hd_nav(inputs)
	if (locale === "it") return it_yt_hd_nav(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hd_nav(inputs)
	if (locale === "pt") return pt_yt_hd_nav(inputs)
	if (locale === "ja") return ja_yt_hd_nav(inputs)
	return zh_yt_hd_nav(inputs)
};